import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContratoTransportadoraFormDialogComponent } from '../app/home/contrato_transportadora/contrato-transportadora-form-dialog.component';
import { Observable, Subscription, interval, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { format } from 'date-fns';
import { ContratoTerrestreFormDialogComponent } from '../app/home/contrato_terrestre/contrato-terrestre-form-dialog.component';
import { ExtraRequestComponent } from '../app/home/extra-request/extra-request.component';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { AppModule } from '../app.module';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';
import { readFile } from 'xlsx';
import { MatRadioModule } from '@angular/material/radio';
import axios, { AxiosResponse } from 'axios';
import { SeuServicoDeBuscaService } from '../services/seu-servico-de-busca.service'
import { error } from 'highcharts/highcharts.src';
import { PrimeNGConfig } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { SendEmailsService } from '../services/send-emails.service';
import { EmailConfig } from '../shared/tipos/interfaces';

@Component({
  selector: 'app-extra-freight',
  templateUrl: './extra-freight.component.html',
  styleUrls: ['./extra-freight.component.css'],
  standalone: false
})
export class ExtraFreightComponent {
  item: any = {};
  items: any[] = [];
  filtereditems: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaRangeDatas: string = 'https://5eqqes9yi5.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'extraFreight';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  querylocation: string = 'Fornecedores_Karrara_Transport';
  queryContrato: string = 'TransportadoresFreteExtra';
  queryTimeTable: string = 'janelasTimeTable';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  existingExcelFile: string = 'C:/Users/ssbuif/Desktop/Transport Instruction-teste.xlsx';
  locais!: any[]
  coordBuscada!: [number, number];
  itemOriginal: any = {};

  typesVehicles: string[] = [
    'Picape(fiorino) Aberta 500Kg - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Fechada - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Refrigerada - C1,60 x L1,00 x A1,20',
    // 'Kombi 800kg - C1,60 x L1,00 x A1,20',
    'VAN Furgão 1,5t - C3,20 x L1,80 x A1,80',
    // 'HR Bongo 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Sider 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Aberto 1,5t - C2,80 x L1,80 x A1,80',
    // 'HR Bongo Refrigerado 1,5t - C2,80 x L1,80 x A1,80',
    // 'VUC - 3/4 3t - C4,80 x L2,20 x A2,20',
    'Caminhão - 3/4 Aberto 3t - C4,80 x L2,20 x A2,20',
    'Caminhão - 3/4 Sider 3t - C4,80 x L2,20 x A2,20',
    // 'VUC - 3/4 Refrigerado 3t - C4,80 x L2,20 x A2,20',
    'Toco Aberto 6ton - C6,50 x L2,40 x A2,60',
    'Toco Sider 6ton - C6,50 x L2,40 x A2,60',
    // 'Toco 6ton Refrigerado - C6,50 x L2,40 x A2,60',
    'Truck Aberto 12ton - C8,50 x L2,40 x A2,70',
    'Truck Sider 12ton - C8,50 x L2,40 x A2,70',
    //'Truck Refrigerado 12ton - C8,50 x L2,40 x A2,70',
    'Carreta 25ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 25ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 25ton Baú - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 27ton Baú - C14,80 x L2,50 x A2,70',
    'Truck Munk',
    'Caminhão Prancha'
  ];
  typesVehiclesTransportador!: string[];
  dialogOpen!: boolean;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  contactCarrier: string = '';
  contactTrasport: string = '+5511974882943';
  status: string = 'Requested';
  dataNotify: any;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  isLoading: boolean = true;
  isUserEnabled: boolean = false;
  isAdminEnabled: boolean = false;
  locationDeliveryChanged!: boolean;
  locationPickupChanged!: boolean;
  subscription: Subscription | undefined;
  // endDate: string | number | Date;
  endDate: Date = new Date();
  startDate: Date = new Date();
  endDateIni!: string;
  startDateIni!: string;
  startDateFilter!: Date;// Data de início do intervalo selecionado
  endDateFilter!: Date; // Data de término do intervalo selecionado
  dateInicial = new Date('1970-01-02')
  temCaracterEspecial: boolean = false;

  @ViewChild('dateInput') dateInput: any;
  @ViewChild('dateInput2') dateInput2: any;
  @ViewChild('dateInput3') dateInput3: any;
  @ViewChild('dateInput4') dateInput4: any;
  allItems: any[] = [];
  contatoColeta!: string;
  telefoneColeta!: string;
  contatoEntrega!: string;
  telefoneEntrega!: string;
  dataRota!: {
    //testando antes de enviar para os carriers
    // "phone_number": this.contactCarrier,
    start_location: number[]; end_location: number[];
  };
  rota!: [number, number] | null;
  itemPickup: any;
  itemDelivery: any;
  coordenadaPickup: any;
  coordenadaDelivery: any;
  distancia!: number;
  tempoViagem!: string;
  contratos!: any[];
  freteCalc!: number;
  openCageApiKey = '4f0c7efe1cfc482682f242ce369892fa';
  coordenadaPickupBusc!: any;
  coordenadaDeliveryBusc!: any;
  cepPickup!: string;
  cepDelivery!: string;
  otherlocationPickupValid: boolean = true;
  otherlocationDeliveryValid: boolean = true;
  referenceDate: any;
  numDays: number = 30;
  filterColumn: string = 'date';
  tituloPagina: string = 'Fretes Extra Não Finalizados';
  itemsIncluindoFinalizados!: any[];
  itemsBruto!: any[];
  filtroAtivado: boolean = false;
  date3!: string;
  date2!: any;
  datetime12h: Date[] | undefined;
  datetime24h: Date[] | undefined;
  time: Date[] | undefined;
  telefoneCelularResp: string = "99759-4640"
  telefoneFixoResp: string = "3190-3643"
  ssbResp: string = "SBTVGP"
  emailConfig: EmailConfig = {
    to: 'luis.silva3@scania.com',
    subject: 'teste extra frete',
    message: 'testando envio via angular',
    response: ''
  }

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private buscaService: SeuServicoDeBuscaService,
    private primengConfig: PrimeNGConfig,
    private emailService: SendEmailsService
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.primengConfig.ripple = true;
    // console.log(this.startDateIni)
    // console.log(this.endDateIni)
    // console.log(this.startDate)
    // console.log(this.endDate)
    await this.getUsers();
    await this.getUserLogado();
    await this.getItemsFromOrigin();
    await this.getCarriers();
    await this.enableFields();
    await this.getItemsFromDynamoDB();
    await this.getContratos();
    await this.getItemsFromDynamoDBComData();
    // //console.log(this.items)
    this.isLoading = false;
    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.upDate();
      await this.enableFields();
      this.isLoading = false;
      // }, 1500);
    });
  }

  async upDate() {
    // console.log(this.startDateIni)
    // console.log(this.endDateIni)
    // console.log(this.startDate)
    // console.log(this.endDate)
    if ((this.startDateIni === undefined && this.endDateIni === undefined) || (this.startDateIni == "Invalid Date" && this.endDateIni == "Invalid Date") ||
      (this.startDateIni == "" && this.endDateIni == "")) {
      // console.log('entrou no update');
      await this.getItemsFromDynamoDB();
      // console.log('passou do get');
      await this.getItemsFromOrigin();
      // console.log('passou do origin');
      this.isLoading = false;
    }
  }

  onCarrierChange(event: any): void {
    //apenas teste, para saber quando seleciona o carrier
    const selectedValue = event.target.value;
    // console.log('Selected carrier:', selectedValue);
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
  }

  editDialog(item: any): void {
    this.itemOriginal = { ...item };
    this.campoTocado = false;
    this.enableFields();
    this.item = {
      ...item
    }
    this.item.reqName = item.reqName ? item.reqName : this.usuarioLogado.nome;
    this.item.reqId = item.reqId ? item.reqId : this.usuarioLogado.id;
    this.item.coordenadaDeliveryBusc = item.coordenadaDeliveryBusc ? item.coordenadaDeliveryBusc : [0, 0];
    this.item.coordenadaPickupBusc = item.coordenadaPickupBusc ? item.coordenadaPickupBusc : [0, 0];
    this.dialogOpen = true;
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  async onFieldChanged(fieldName: string, newValue: string) {
    if (fieldName == 'locationDelivery') {
      this.item.addressDelivery = null
      this.item.cityDelivery = null
      this.item.stateDelivery = null
      this.item.cepDelivery = null
      this.item.numberDelivery = null
      if (newValue != 'other') {
        this.item.addressDelivery = (this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco :
          await this.buscarEnderecoPelaCoordenada(this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).latitude, this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).longitude))
      }
    } else if (fieldName == 'locationPickup') {
      this.item.addressPickup = null
      this.item.cityPickup = null
      this.item.statePickup = null
      this.item.cepPickup = null
      this.item.numberPickup = null
      if (newValue != 'other') {
        this.item.addressPickup = (this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco :
          await this.buscarEnderecoPelaCoordenada(this.itemsOrigin?.find(end => end.local == this.item.locationPickup).latitude, this.itemsOrigin?.find(end => end.local == this.item.locationPickup).longitude))
      }
    }
  }

  solicitarFrete() {
    this.item = {};
    this.item.reqName = this.usuarioLogado.nome;
    this.item.reqId = this.usuarioLogado.id;
    this.item.ID = format(new Date(), 'ddMMyyyyHHmmss');
    this.item.status = 'NOVA SOLICITAÇÃO';
    this.item.quantity = 1;
    // this.item.date = new Date();
    this.rota = [0, 0];
    this.distancia = 0;
    this.tempoViagem = '';
    this.freteCalc = 0;
    this.coordenadaDelivery = 0;
    this.coordenadaPickup = 0;
    this.cepPickup = '';
    this.cepDelivery = '';
    this.dialogOpen = true;
    this.coordenadaPickupBusc = [0, 0];
    this.coordenadaDeliveryBusc = [0, 0];
    //console.log(this.item.date)
  }

  verificarCaracteresEspeciais() {
    // Utiliza uma expressão regular para verificar caracteres especiais
    this.temCaracterEspecial = /[^\w\s]/.test(this.item.description);
  }

  converterSegundosParaHoraMinutos(segundos: number): string {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    return `${horas}:${minutos}`;
  }

  calcularFrete(veiculo: string, distancia: number) {
    // console.log("entrou no calcular rota");
    // console.log(veiculo);
    // console.log(distancia);
    let dist = '';
    let valorCorrespondente = '';
    let valorCorrespondenteNumber = 0;
    const contrato = this.contratos?.find(cont => cont.transportadora == this.item.carrier)
    // console.log(contrato)
    if (distancia <= 50) {
      dist = 'km0a50';
    } else if (distancia > 50 && distancia <= 100) {
      dist = 'km51a100';
    } else if (distancia > 100 && distancia <= 200) {
      dist = 'km101a200';
    } else if (distancia > 200 && distancia <= 500) {
      dist = 'km201a500';
    } else if (distancia > 500 && distancia <= 1000) {
      dist = 'km501a1000';
    } else if (distancia > 1000) {
      dist = 'km1000';
    }
    // console.log(dist)
    // Iterar sobre os objetos no array
    for (const veiculoItem of contrato.veiculo) {
      // Verificar se a chave de comparação existe no objeto atual
      if (dist in veiculoItem && veiculoItem.modelo == veiculo) {
        // Obter o valor correspondente
        valorCorrespondente = veiculoItem[dist];
        // console.log(typeof valorCorrespondente);
        valorCorrespondenteNumber = parseFloat(valorCorrespondente.replace(',', '.'));
        // valorCorrespondenteNumber = parseFloat(valorCorrespondente)
        // console.log(valorCorrespondenteNumber);
        // Pode interromper o loop aqui se desejar
        break;
      }
    }
    // console.log(distancia)
    const frete = valorCorrespondenteNumber * distancia;
    // console.log(frete);
    return frete;
  }

  async buscarEndereco(): Promise<number[]> {
    try {
      let coordenadaPickup = [0, 0]
      return new Promise((resolve, reject) => {
        // console.log(this.item.cepPickup)
        this.buscaService.buscarEnderecoPorCep(this.item.cepPickup)
          .subscribe(async (endereco) => {
            if (endereco && !endereco.erro) {
              // Faz o que for necessário com o endereço retornado
              if (endereco.uf) {
                this.item.statePickup = endereco.uf;
              }
              if (endereco.localidade) {
                this.item.cityPickup = endereco.localidade;
              }
              if (endereco.logradouro) {
                this.item.addressPickup = endereco.logradouro;
              }
              // try {
              //   // console.log(endereco.logradouro)
              //   // console.log(endereco.localidade)
              //   const coordBuscada = await this.buscarCoordenadasEnd(endereco.logradouro, endereco.localidade);
              //   // console.log('coordBuscada')
              //   // console.log(coordBuscada)
              //   coordenadaPickup = [coordBuscada.latitude, coordBuscada.longitude];
              //   this.coordenadaPickupBusc = coordenadaPickup.map(coordenada => Number(coordenada));
              //   resolve(coordenadaPickup);
              // } catch (error) {
              //   console.error('Erro ao buscar coordenadas de coleta:', error);
              //   resolve([0, 0]); // Resolving with default coordinates
              // }
            } else {
              console.warn('CEP não encontrado ou inválido.');
              alert("CEP não encontrado ou inválido!")
              // this.isLoading = false;
              resolve([0, 0]);
            }
          }, error => {
            console.error('Erro ao buscar endereço por CEP:', error);
            reject(error);
          });
      });
    } catch {
      alert('Verifique o CEP digitado !')
      return [0]
    }
  }

  async buscarEnderecoEntrega(): Promise<number[]> {
    let coordenadaDelivery = [0, 0]
    try {
      return new Promise((resolve, reject) => {
        this.buscaService.buscarEnderecoPorCep(this.item.cepDelivery)
          .subscribe(async (endereco) => {
            if (endereco && !endereco.erro) {
              // Faz o que for necessário com o endereço retornado
              if (endereco.uf) {
                this.item.stateDelivery = endereco.uf;
              }
              if (endereco.localidade) {
                this.item.cityDelivery = endereco.localidade;
              }
              if (endereco.logradouro) {
                this.item.addressDelivery = endereco.logradouro;
              }
              // try {
              //   const coordBuscadaEntrega = await this.buscarCoordenadasEnd(endereco.logradouro, endereco.localidade);
              //   coordenadaDelivery = [coordBuscadaEntrega.latitude, coordBuscadaEntrega.longitude];
              //   // console.log('Coordenadas de entrega:' + coordenadaDelivery);
              //   this.coordenadaDeliveryBusc = coordenadaDelivery.map(coordenada => Number(coordenada));
              //   resolve(coordenadaDelivery);
              // } catch (error) {
              //   console.error('Erro ao buscar coordenadas de entrega:', error);
              //   resolve([0, 0]); // Resolving with default coordinates
              // }
            } else {
              console.warn('CEP não encontrado ou inválido.');
              alert("CEP não encontrado ou inválido!")
              // this.isLoading = false;
              resolve([0, 0]);
            }
          }, error => {
            console.error('Erro ao buscar endereço por CEP:', error);
            reject(error);
          });
      });
    } catch {
      alert('Verifique o CEP digitado !')
      return [0]
    }
  }

  // buscarCoordenadasEnd(logradouro: string, cidade: string): Promise<{ latitude: number, longitude: number }> {
  //   return new Promise<{ latitude: number, longitude: number }>((resolve, reject) => {
  //     this.buscaService.buscarCoordenadasPorLogradouroEcidade(logradouro, cidade, this.openCageApiKey)
  //       .subscribe(
  //         (resultado: any) => {
  //           if (resultado.results.length > 0) {
  //             const latitude = resultado.results[0].geometry.lat;
  //             const longitude = resultado.results[0].geometry.lng;
  //             // console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
  //             resolve({ longitude, latitude });
  //           } else {
  //             console.log('Endereço não encontrado');
  //             reject('Endereço não encontrado');
  //           }
  //         },
  //         error => {
  //           console.error('Erro ao buscar coordenadas:', error);
  //           const confirmacao = window.confirm("CEP não encontrado!");
  //           reject(error);
  //         }
  //       );
  //   });
  // }

  buscarEnderecoPelaCoordenada(latitude: number, longitude: number): Promise<any> {
    // console.log(latitude)
    // console.log(longitude)
    return new Promise<{ latitude: number, longitude: number }>((resolve, reject) => {
      this.buscaService.getAddress(latitude, longitude, this.openCageApiKey)
        .subscribe(
          (resultado: any) => {
            if (resultado.results.length > 0) {
              // console.log(resultado.results[0].formatted );
              resolve(resultado.results[0].formatted);
            } else {
              console.log('Endereço não encontrado');
              reject('Endereço não encontrado');
            }
          },
          error => {
            console.error('Erro ao buscar coordenadas:', error);
            const confirmacao = window.confirm("Endereço não encontrado!");
            reject(error);
          }
        );
    });
  }

  getLatLngByCep(cep: string): Observable<{ lat: string; lng: string }> {
    return this.http.get<any>(`https://cep.awesomeapi.com.br/json/${cep}`)
      .pipe(map(res => ({ lat: res.lat, lng: res.lng })));
  }

  async salvar(item: any) {
    if (((item.locationDelivery && item.locationDelivery.includes("LCB")) || (item.otherLocationDelivery && item.otherLocationDelivery.includes("LCB"))) && item.quantity <= 1) {
      window.confirm("Por favor preencha a quantidade de itens! (Pallets)")
      // if (confirmacao || !confirmacao) {
      return
      // }
    }
    // console.log(item)
    // debugger
    // if(item.locationPickup != "other")
    this.item.date = item.date ? item.date : new Date();
    this.otherlocationDeliveryValid = true;
    this.otherlocationPickupValid = true;
    this.item.addressPickup = item.addressPickup;
    this.item.cityPickup = item.cityPickup;
    this.item.statePickup = item.statePickup;
    this.item.addressDelivery = item.addressDelivery;
    this.item.cityDelivery = item.cityDelivery;
    this.item.stateDelivery = item.stateDelivery;
    let coordPickup: number[] = [0, 0];
    let coordDelivery: number[] = [0, 0];
    this.distancia = 0;
    this.tempoViagem = "0";
    this.freteCalc = 0;
    let coordenadaPickup = ["0", "0"]
    let coordenadaDelivery = ["0", "0"]
    this.isLoading = true;
    if (item.locationPickup == "other") {
      if (this.item.cepPickup) {
        try {
          const pickup = await firstValueFrom(this.getLatLngByCep(this.item.cepPickup));
          const coords = [parseFloat(pickup.lat), parseFloat(pickup.lng)];
          this.coordenadaPickupBusc = coords;
        } catch {
          alert('Não foi possivel calcular a distância, devido ao CEP que foi inserido no local de coleta !')
        }
      }
    }
    if (item.locationDelivery == "other") {
      if (this.item.cepDelivery) {
        try {
          const entrega = await firstValueFrom(this.getLatLngByCep(this.item.cepDelivery));
          this.coordenadaDeliveryBusc = [parseFloat(entrega.lat), parseFloat(entrega.lng)];
        } catch {
          alert('Não foi possivel calcular a distância, devido ao CEP que foi inserido no local de entrega !')
        }
      }
    }
    this.itemPickup = this.itemsOrigin?.find(end => end.local == this.item.locationPickup) ? this.itemsOrigin?.find(end => end.local == this.item.locationPickup) : undefined
    this.itemDelivery = this.itemsOrigin?.find(end => end.local == this.item.locationDelivery) ? this.itemsOrigin?.find(end => end.local == this.item.locationDelivery) : undefined
    if (this.itemPickup !== undefined) {
      coordenadaPickup = [this.itemPickup.longitude, this.itemPickup.latitude]
    } else if (this.coordenadaPickupBusc) {
      if ((this.coordenadaPickupBusc && this.coordenadaPickupBusc[0] !== undefined && this.coordenadaPickupBusc[0] !== 0) && (this.coordenadaPickupBusc[1] !== undefined && this.coordenadaPickupBusc[1] !== 0)) {
        coordenadaPickup = [this.coordenadaPickupBusc[1].toString(), this.coordenadaPickupBusc[0].toString()]
      }
    } else if (this.item.coordenadaPickupBusc) {
      if (this.item.coordenadaPickupBusc && this.item.coordenadaPickupBusc[0] !== undefined && this.item.coordenadaPickupBusc[0] !== 0 && this.item.coordenadaPickupBusc[1] !== undefined && this.item.coordenadaPickupBusc[1] !== 0) {
        console.log("entrou no elseif 2")
        coordenadaPickup = [this.item.coordenadaPickupBusc[1].toString(), this.item.coordenadaPickupBusc[0].toString()]
      }
    }
    else {
      coordenadaPickup = ["0", "0"]
    }
    if (this.itemDelivery !== undefined) {
      coordenadaDelivery = [this.itemDelivery.longitude, this.itemDelivery.latitude]
    } else if ((this.coordenadaDeliveryBusc && this.coordenadaDeliveryBusc[0] !== undefined && this.coordenadaDeliveryBusc[0] !== 0) && (this.coordenadaDeliveryBusc[1] !== undefined && this.coordenadaDeliveryBusc[1] !== 0)) {
      coordenadaDelivery = [this.coordenadaDeliveryBusc[1].toString(), this.coordenadaDeliveryBusc[0].toString()]
    } else if (this.item.coordenadaDeliveryBusc && this.item.coordenadaDeliveryBusc[0] !== undefined && this.item.coordenadaDeliveryBusc[0] !== 0 && this.item.coordenadaDeliveryBusc[1] !== undefined && this.item.coordenadaDeliveryBusc[1] !== 0) {
      coordenadaDelivery = [this.item.coordenadaDeliveryBusc[1].toString(), this.item.coordenadaDeliveryBusc[0].toString()]
    } else {
      coordenadaDelivery = ["0", "0"]
    }
    this.coordenadaPickup = coordenadaPickup.map(coordenada => Number(coordenada));
    this.coordenadaDelivery = coordenadaDelivery.map(coordenada => Number(coordenada));
    try {
      if (item.locationPickup == "other") {
        if (
          !this.item.numberPickup ||
          !this.item.cityPickup ||
          !this.item.cepPickup) {
          this.otherlocationPickupValid = false;
        }
      }
      if (item.locationDelivery == "other") {
        if (
          !this.item.numberDelivery ||
          !this.item.cityDelivery ||
          !this.item.cepDelivery) {
          this.otherlocationDeliveryValid = false;
        }
      }
      if (
        this.item.reqEmail &&
        this.item.reqId &&
        this.item.reqName &&
        this.item.reqPhone &&
        this.item.costCenter &&
        this.item.locationPickup &&
        this.item.datePickup &&
        this.item.timePickup &&
        this.item.locationDelivery &&
        this.item.dateDelivery &&
        this.item.timeDelivery &&
        this.item.tipo &&
        this.item.reqVehicle &&
        this.item.addressPickup &&
        this.item.addressDelivery &&
        this.otherlocationPickupValid &&
        this.otherlocationDeliveryValid
      ) {
        if (this.coordenadaPickup[0] != 0 && this.coordenadaPickup[1] != 0 && this.coordenadaDelivery[0] != 0 && this.coordenadaDelivery[1] != 0 &&
          !isNaN(this.coordenadaDelivery[0]) && !isNaN(this.coordenadaPickup[0]) && !isNaN(this.coordenadaDelivery[1]) && !isNaN(this.coordenadaPickup[1])) {
          try {
            this.rota = await this.calcularRota(this.coordenadaPickup, this.coordenadaDelivery);
            if (this.rota && this.rota.length > 0) {
              if (this.rota[0] < 40) {
                if ((this.item.cityPickup && this.item.cityPickup.toUpperCase().includes('SÃO PAULO')) ||
                  (this.item.cityPickup && this.item.cityPickup.toUpperCase().includes("SAO PAULO")) ||
                  (this.item.cityDelivery && this.item.cityDelivery.toUpperCase().includes("SÃO PAULO")) ||
                  (this.item.cityDelivery && this.item.cityDelivery.toUpperCase().includes('SAO PAULO'))) {
                  this.rota[0] = 40;
                } else {
                  if (this.rota[0] < 30) {
                    this.rota[0] = 30;
                  } else {
                    this.rota[0] = this.rota[0];
                  }
                }
              }
              this.distancia = this.rota ? this.rota[0] : 0;
              const segundosTotais = this.rota ? this.rota[1] : 0;
              this.tempoViagem = this.converterSegundosParaHoraMinutos(segundosTotais);
              this.freteCalc = await this.calcularFrete(this.item.reqVehicle, this.distancia);
            }
          } catch {
            console.log("Não tem dados suficientes para calcular o frete !")
          }
        } else {
          console.log("NAO entrou no calculo distancia")
          this.distancia = 0;
          this.tempoViagem = "0";
          this.freteCalc = 0;
          console.log("Não tem dados suficientes para calcular o frete !")
        }
        this.item = {
          "ID": this.item.ID,
          "date": this.item.date,
          "motive": this.item.motive,
          "nf": this.item.nf,
          "nfTotal": this.item.nfTotal,
          "weight": this.item.weight,
          "quantity": this.item.quantity,
          "carrier": this.item.carrier,
          "reqVehicle": this.item.reqVehicle,
          "vehicleType": this.item.vehicleType,
          "plate": this.item.plate,
          "totalCost": this.item.totalCost,
          "description": this.item.description,
          "reqName": this.item.reqName,
          "reqId": this.item.reqId,
          "region": this.item.region,
          "reqEmail": this.item.reqEmail,
          "reqPhone": this.item.reqPhone,
          "supEmail": this.item.supEmail,
          "costCenter": this.item.costCenter,
          "projectNumber": this.item.projectNumber,
          "orderNumber": this.item.orderNumber,
          "locationPickup": this.item.locationPickup,
          "areaPickup": this.item.areaPickup,
          "contatoPickup": this.item.contatoPickup,
          "telefonePickup": this.item.telefonePickup,
          "addressPickup": this.item.addressPickup,// ? this.item.addressPickup : this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco,
          "numberPickup": this.item.numberPickup,
          "cityPickup": this.item.cityPickup,
          "statePickup": this.item.statePickup,
          "cepPickup": this.item.cepPickup,
          "datePickup": this.item.datePickup,
          "timePickup": this.item.timePickup,
          "locationDelivery": this.item.locationDelivery,
          "otherLocationPickup": this.item.otherLocationPickup,
          "otherLocationDelivery": this.item.otherLocationDelivery,
          "areaDelivery": this.item.areaDelivery,
          "contatoDelivery": this.item.contatoDelivery,
          "telefoneDelivery": this.item.telefoneDelivery,
          "dateDelivery": this.item.dateDelivery,
          "addressDelivery": this.item.addressDelivery, //? this.item.addressDelivery : this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco,
          "numberDelivery": this.item.numberDelivery,
          "cityDelivery": this.item.cityDelivery,
          "stateDelivery": this.item.stateDelivery,
          "cepDelivery": this.item.cepDelivery,
          "timeDelivery": this.item.timeDelivery,
          "notes": this.item.notes,
          "critical": this.item.critical,
          "dangerousProduct": this.item.dangerousProduct,
          "status": this.item.status == 'NOVA SOLICITAÇÃO' || !this.item.status ? 'Requested' : this.item.status,
          "tipo": this.item.tipo,
          "distancia": this.distancia,
          "tempo": this.tempoViagem,
          "freteCalculado": this.freteCalc.toString(),
          "coordenadaDeliveryBusc": this.coordenadaDelivery.toString(),
          "coordenadaPickupBusc": this.coordenadaPickup.toString(),
        }
        this.item.tableName = this.query

        const alterados: { campo: string, antes: any, depois: any }[] = [];
        for (const key in item) {
          if (item[key] !== this.itemOriginal[key]) {
            // console.log("novo:",item[key]);
            // console.log("original:", this.itemOriginal[key]);

            alterados.push({
              campo: key,
              antes: this.itemOriginal[key],
              depois: item[key]
            });
          }
        }
        // console.log("costCenter:", item['costCenter']);
        // console.log("Campos alterados:", alterados);
        const alteracaoStatus = await alterados.find(a => a.campo === 'status');
        const alteracaoCarrier = await alterados.find(a => a.campo === 'carrier');
        const alteracaoCC = await alterados.find(a => a.campo == 'costCenter');
        const alteracaoVehicle = await alterados.find(a => a.campo === 'vehicleType');
        // console.log("alteracaoCC:", alteracaoCC);
        if (alteracaoStatus) {
          this.emailConfig = {
            to: 'erick.filipini@scania.com',
            subject: 'Status do Frete Extra alterado',
            message: `Frete extra ID ${item.ID}, alterado para ${alteracaoStatus.depois}.`,
            response: ''
          }
          // this.sendEmail();
        }
        if (alteracaoCarrier) {
          const carriersEmail = this.carriers.find(item => item.name === alteracaoCarrier.depois).contato;
          // console.log(carriersEmail)
          const dest = carriersEmail;
          this.emailConfig = {
            to: dest,
            subject: 'Novo Frete Extra solicitado',
            message: `Foi solicitado um novo frete extra ID ${item.ID}.`,
            response: ''
          }
          this.sendEmail();
        }
        if (alteracaoCC) {
          // console.log('entrou no CC')
          const emailDest = alteracaoCC.depois == '3061' ? 'Adriano.Santos@scania.com' : alteracaoCC.depois == '3165' ? 'adriano.voros@scania.com' : '';
          // console.log(emailDest)
          this.emailConfig = {
            to: emailDest,
            subject: 'Novo Frete Extra solicitado',
            message: `Foi solicitado um novo frete extra ID ${item.ID}, no centro de custo ${alteracaoCC.depois}. Solicitante ${item.reqId}.`,
            response: ''
          }
          this.sendEmail();
        }
        //  else if (alteracaoVehicle) {
        //   this.emailConfig = {
        //     to: 'luis.silva3@scania.com',
        //     subject: 'Novo Frete Extra solicitado',
        //     message: `Foi solicitado um novo frete extra ID ${item.ID}, no centro de custo 3061. Solicitante ${item.reqId}.`,
        //     response: ''
        //   }
        //   // this.sendEmail("A viagem foi finalizada!");
        // }


        // Remover as barras invertidas escapadas
        const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
        const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
        // Converter a string JSON para um objeto JavaScript
        const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
        // Converter o objeto JavaScript de volta para uma string JSON
        const modifiedJsonString = JSON.stringify(jsonObject);
        // //console.log(modifiedJsonString);
        // Converter a string JSON para um objeto JavaScript
        const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
        // Criar um array contendo o objeto
        const jsonArray = [jsonObject2];
        // console.log(jsonObject2)
        await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
          await this.upDate();
          if (this.item.locationDelivery && (this.item.locationDelivery.includes('LCB') || this.item.locationDelivery.includes('SCANIA'))) {
            await this.salvarNaTimeTable();
          }
          this.dialogOpen = false;
          this.isLoading = false;
        }, error => {
          // debugger
          console.log(error);
          this.dialogOpen = false;
          this.isLoading = false;
        });
      } else {
        this.campoTocado = true;
        alert("Formulario incompleto!")
        this.isLoading = false;
      }
      if (this.item.carrier) {
        // await this.notifyCarrier();
      }
      // await this.upDate();
    } catch (error) {
      const confirmacao = window.confirm("Por favor, revise o preenchimento do formulario!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = false;
        console.error('Error :', error);
      }
    }
  }

  async salvarNaTimeTable() {
    this.isLoading = true;
    const currentDate = new Date().getTime()
    this.item = {
      "ID": this.item.ID,
      "lastUpdate": new Date(),
      "dataJanelaTimeTable": this.item.dateDelivery,
      "dataJanelaOriginal": this.item.dateDelivery,
      "dataJanela": this.item.dateDelivery,
      "horaJanelaTimeTable": this.item.timeDelivery,
      "horaJanelaOriginal": this.item.timeDelivery,
      // "JanelaDestino 1": formattedDate,
      "origem": "FreteExtra",
      // "Janela": formattedDate,
      // "jan1": formattedDate,
      "Plate": this.item.plate,
      "Volumes": this.item.quantity,
      // 'Fornecedor 1': this.item.fornecedor,
      'Fornecedores': this.item.locationPickup,
      "tableName": this.queryTimeTable,
      'area': this.item.locationDelivery == 'LCB DEMARCHI' ? 'RECSIDER' : this.item.locationDelivery == 'SCANIA SBC' ? this.item.areaDelivery : '',
      // 'prioridade': this.item.pecasCritica ? true : false,
      "Transportadora": "FRETE EXTRA",
      'Destino 1': this.item.locationDelivery
    }
    // console.log(this.item)
    const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // console.log(jsonArray)
    await this.dynamodbService.salvar(jsonArray, this.queryTimeTable, this.urlAtualiza).subscribe(async response => {
      // console.log(response)
      await this.upDate();
      this.dialogOpen = false;
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async clearFilter() {
    this.isLoading = true;
    this.filtereditems = this.itemsCompletos;
    this.dateInput3.nativeElement.value = '';
    this.dateInput4.nativeElement.value = '';
    this.startDateIni = ''
    this.endDateIni = ''
    this.filtroAtivado = false;
    // //console.log(this.startDateFilter)
    await this.upDate();
    await this.getItemsFromDynamoDBComData();
  }

  sendEmail() {
    this.emailService.sendEmail(this.emailConfig)
      .subscribe({
        next: res => this.emailConfig.response = `Email enviado com sucesso! MessageId: ${res.messageId}`,
        error: err => this.emailConfig.response = `Erro ao enviar email: ${err.error?.message || err.message}`
      });
  }

  finalizarViagem(item: any) {
    if (item.totalCost) {
      item.status = 'Completed'
    } else {
      const confirmacao = window.confirm("Não é possivel finalizar, sem o valor do frete!");
    }
  }

  async aplicarFiltro() {
    if (!this.searchString) {
      if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
        this.filtereditems = await this.items.filter(item => {
          const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
          itemDate.setHours(0, 0, 0, 0);
          return itemDate >= this.startDate && itemDate <= this.endDate;
        });
      } else {
        this.filtereditems = this.items;
      }
    }
    this.filtereditems = this.filtereditems.filter(item => this.filtrarItem(item));
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    console.log(item)
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }
    const lowerCaseFilter = this.searchString.toLowerCase();
    // Verificar se alguma propriedade do item corresponde ao filtro (ignorando maiúsculas e minúsculas)
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }

  async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // console.log(this.carriers)
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  // async getRota() {
  //   this.rota = await this.calcularRota([-46.633308, -23.550520], [-43.1729, -22.9068]);
  //   // console.log(this.rota);
  // }

  async calcularRota(startLocation: number[], endLocation: number[]): Promise<[number, number] | null> {
    // console.log(startLocation);
    // console.log(endLocation);
    try {
      const response: any = await (await this.dynamodbService.getRota("https://klyufov1p0.execute-api.sa-east-1.amazonaws.com/v1/POST", startLocation, endLocation)).toPromise();
      if (response.statusCode === 200) {
        const data = response.body;
        if (data) {
          const distance = data.Distance;
          const durationSeconds = data.DurationSeconds;
          return [distance, durationSeconds];
        } else {
          console.error('Data not found in the response:', data);
          return null;
        }
      } else {
        console.error('Invalid response:', response);
        return null;
      }
    } catch (error) {
      console.error('Error processing data:', error);
      return null;
    }
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.usuarios = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getContratos(): Promise<void> {
    const filtroContrato = 'All';
    (await this.dynamodbService.getItems(this.queryContrato, this.urlConsulta, filtroContrato)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            // console.log(response)
            const items = JSON.parse(response.body);
            // console.log(items)
            if (Array.isArray(items)) {
              this.contratos = items.map(item => ({ ...item }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  // verificaContato(newValue: string) {
  //   // //console.log("entrou no verifica")
  //   // //console.log(newValue)
  //   this.item.contatoPickup = this.locais.find(item => item.local == newValue).nomeContato
  //   this.item.telefonePickup = this.locais.find(item => item.local == newValue).telefone
  //   // //console.log(this.contatoColeta)
  // }

  verificaContato(newValue: string) {
    try {
      const localEncontrado = this.locais.find(item => item.local == newValue);
      if (localEncontrado) {
        this.item.contatoPickup = localEncontrado.nomeContato || 'Sem nome de contato'; // Substitua 'Valor Padrão' pelo valor desejado
        this.item.telefonePickup = localEncontrado.telefone || 'Sem telefone de contato'; // Substitua 'Valor Padrão' pelo valor desejado
      }
      // } else {
      //   // Trate o caso em que localEncontrado é undefined
      //   console.error('Local não encontrado para:', newValue);
      //   // Pode ser útil definir valores padrão ou tomar outra ação apropriada
      // }
    } catch {
      console.error('Local não encontrado para:', newValue);
    }
  }

  // verificaContatoEntrega(newValue: string) {
  //   // //console.log("entrou no verifica")
  //   // //console.log(newValue)
  //   this.item.contatoDelivery = this.locais.find(item => item.local == newValue).nomeContato
  //   this.item.telefoneDelivery = this.locais.find(item => item.local == newValue).telefone
  //   // //console.log(this.contatoColeta)
  // }

  verificaContatoEntrega(newValue: string) {
    try {
      const localEncontrado = this.locais.find(item => item.local == newValue);
      if (localEncontrado) {
        this.item.contatoDelivery = localEncontrado.nomeContato || 'Sem nome de contato'; // Substitua 'Valor Padrão' pelo valor desejado
        this.item.telefoneDelivery = localEncontrado.telefone || 'Sem telefone de contato'; // Substitua 'Valor Padrão' pelo valor desejado
      }
      // else {
      //   // Trate o caso em que localEncontrado é undefined
      //   console.error('Local não encontrado para:', newValue);
      //   // Pode ser útil definir valores padrão ou tomar outra ação apropriada
      // }
    } catch {
      console.error('Local não encontrado para:', newValue);
    }
  }

  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
    this.locationDeliveryChanged = false;
    this.locationPickupChanged = false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log(this.usuarioLogado)
  }


  getStatusClass(status: string): string {
    if (status == 'Planned') {
      this.status = 'planned';
      return 'planned';
    } else if (status == 'Executing') {
      return 'executing';
    } else if (status == 'Completed') {
      return 'completed';
    } else if (status == 'Canceled') {
      return 'canceled';
    } else if (status == 'Reject') {
      return 'rejected';
    } else if (status == 'NOVA SOLICITAÇÃO') {
      return 'novaSolicitacao';
    } else {
      return '';
    }
  }

  // async openDialog(item: Array<any>, url: string, table: string): Promise<void> {
  //   const dialogRef: MatDialogRef<ExtraRequestComponent> = this.dialog.open(ExtraRequestComponent, {
  //     data: {
  //       itemsData: [],
  //       url: url,
  //       query: table
  //     },
  //     height: '730px',
  //     minWidth: '750px',
  //     position: {
  //       top: '10vh',
  //       left: '30vw'
  //     },
  //   });
  //   await dialogRef.afterClosed().subscribe(async () => {
  //     // if (result) {
  //     // setTimeout(() => {
  //     await this.getItemsFromDynamoDB();
  //     // }, 800); // Ajuste o tempo de atraso conforme necessário
  //   }
  //     // //console.log('The dialog was closed');
  //     // }
  //   );
  // }


  async getItemsFromOrigin(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.querylocation, this.urlConsulta, filtro)).subscribe(
      async (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.itemsOrigin = items.map(item => ({ ...item, checked: false }));

              // Ordena os itens em ordem alfabética com base na propriedade 'local'
              await this.itemsOrigin.sort((a, b) => a.local.localeCompare(b.local));

              // Salva os locais ordenados em this.placesOrigin
              this.placesOrigin = this.itemsOrigin.map(item => item.local);
              this.locais = items;
              // //console.log(this.placesOrigin)
              // //console.log(items)                          
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async getItemsFromDynamoDBComData(): Promise<void> {
    // console.log(this.filtroAtivado)
    this.isLoading = true;
    let referenceDateStart: string;
    let referenceDateEnd: string;
    if (this.startDateIni !== undefined && this.endDateIni !== undefined && this.startDateIni !== "Invalid Date" && this.endDateIni !== "Invalid Date" &&
      this.startDateIni !== "" && this.endDateIni !== "") {
      const startDate = new Date(this.startDateIni + "T00:00:00");
      const endDate = new Date(this.endDateIni + "T23:59:00");
      referenceDateStart = this.convertTimestampToFormattedDate(startDate.getTime());
      referenceDateEnd = this.convertTimestampToFormattedDate(endDate.getTime());
      // Calcula a diferença em milissegundos e converte para dias
      const diffInMs = endDate.getTime() - startDate.getTime();
      this.numDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
      this.numDays = this.numDays > 0 ? this.numDays : this.numDays = 1;
      // console.log(this.numDays)
    } else {
      // referenceDate = this.convertTimestampToFormattedDate(Date.now());
      referenceDateEnd = this.convertTimestampToFormattedDate(Date.now());
      const dataAtual = new Date();
      dataAtual.setHours(23, 59, 59, 999); // Define as horas, minutos, segundos e milissegundos
      // Subtrai 30 dias (30 dias * 24 horas * 60 minutos * 60 segundos * 1000 milissegundos)
      const diasParaSubtrair = 30;
      const dataPassada = new Date(dataAtual.getTime() - diasParaSubtrair * 24 * 60 * 60 * 1000);
      dataPassada.setHours(0, 0, 0, 0); // Define as horas, minutos, segundos e milissegundos
      referenceDateStart = this.convertTimestampToFormattedDate(dataPassada.getTime());
      this.numDays = 30;
      // console.log(this.numDays)
    }
    // console.log(referenceDateStart)
    // console.log(referenceDateEnd)
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsRangeData(this.query, this.urlConsultaRangeDatas, 'All', this.filterColumn, referenceDateStart, referenceDateEnd, this.numDays)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode == 200) {
        try {
          // //console.log(response.body)
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.itemsBruto = items.map(item => ({ ...item, checked: false }));
            if (this.usuarioLogado.role.toString() == '1' || this.usuarioLogado.role.toString() == '6' || this.usuarioLogado.role.toString() == '5') {
              if (this.usuarioLogado)
                this.itemsBruto = await items.filter(item => item.reqId.toLowerCase() == this.usuarioLogado.id.toLowerCase())
            }
            else if (this.usuarioLogado.role != '9' && this.usuarioLogado.role != '2') {
              this.itemsBruto = await items.filter(item => item.carrier == this.usuarioLogado.company)
            }
            this.itemsIncluindoFinalizados = this.itemsBruto;
            // console.log(this.itemsIncluindoFinalizados)
            if (this.filtroAtivado) {
              // this.items = await this.itemsBruto.filter(item => item.status != 'Canceled' && item.status != 'Completed');
              this.items = this.itemsBruto;
              this.items.sort((a, b) => {
                try {
                  return b.date.localeCompare(a.date);
                } catch {
                  // console.log(a);
                  // console.log(b);
                }
              });
              // console.log(this.startDateFilter)
              // console.log(this.endDateFilter)
              // console.log(this.dateInicial)
              // if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
              // console.log('Entrou no filtro com datas')
              //   this.filtereditems = await this.items.filter(item => {
              //     const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
              //     itemDate.setHours(0, 0, 0, 0);
              //     return itemDate >= this.startDate && itemDate <= this.endDate;
              //   });
              // } else {
              this.filtereditems = this.items;
              // }
              this.itemsCompletos = this.items;
              this.cdr.detectChanges();
              // console.log(this.startDateIni)
              const data = new Date(this.startDateIni + "T00:00:00");
              const mes = data.getMonth() + 1; // Janeiro é 0, então somamos 1
              // console.log(mes); // 1
              const meses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
              const nomeMes = meses[data.getMonth()];
              // console.log(nomeMes); // "Janeiro"

              const dataEnd = new Date(this.endDateIni + "T00:00:00");
              const mesEnd = dataEnd.getMonth() + 1; // Janeiro é 0, então somamos 1
              // console.log(mesEnd); // 1
              const nomeMesEnd = meses[dataEnd.getMonth()];
              // console.log(nomeMesEnd); // "Janeiro"
              if (nomeMes != nomeMesEnd) {
                this.tituloPagina = 'Fretes Extras dos meses de ' + nomeMes + ' até ' + nomeMesEnd;
              } else if (nomeMes == nomeMesEnd) {
                this.tituloPagina = 'Fretes Extras mês de ' + nomeMes;
              }
            }
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
        this.isLoading = false;
      } else {
        console.error('Invalid response:', response);
        this.isLoading = false;
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
      alert('Período maximo de 1 mês para pesquisa!');
      this.isLoading = false;
    }
    // this.filtroAtivado = false;
  }

  async getItemsFromDynamoDB(): Promise<void> {
    try {
      const lambdaEvent = {
        "tableName": "extraFreight",
        "searchConditions": [
          { "column": "status", "word": "Canceled", "negate": true },
          { "column": "status", "word": "Completed", "negate": true },
          // { "column": "Finalizada", "word": "true", "negate": true },
          // { "column": "Finalizada", "word": "True", "negate": true }
        ]
      };
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {

        // this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
        // try {
        //   const response: any = await new Promise(async (resolve, reject) => {
        //     (await this.dynamodbService.getItemsVolumesAltos('extraFreight', this.urlConsultaCompactada, 'All', 'date', this.referenceDate, 15)).subscribe(
        //       (res: any) => resolve(res),
        //       (error: any) => reject(error)
        //     );
        //   });
        //   if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // console.log(items)
          this.allItems = items;
          // this.allItems.forEach(item => {
          //   if(item.ID == "18122024152541"){
          //   console.log(this.allItems)
          //   }
          // })
          if (Array.isArray(items)) {
            this.items = items.map(item => ({ ...item, checked: false }));
            if (this.usuarioLogado.role.toString() == '1' || this.usuarioLogado.role.toString() == '6' || this.usuarioLogado.role.toString() == '5') {
              if (this.usuarioLogado)
                this.items = await items.filter(item => item.reqId.toLowerCase() == this.usuarioLogado.id.toLowerCase())
            }
            else if (this.usuarioLogado.role != '9' && this.usuarioLogado.role != '2' && this.usuarioLogado.role != '7') {
              this.items = await items.filter(item => item.carrier == this.usuarioLogado.company)
            }
            this.items = await this.items.filter(item => item.status != 'Canceled' && item.status != 'Completed')
            this.items.sort((a, b) => {
              try {
                return b.date.localeCompare(a.date);
              } catch {
                // console.log(a);
                // console.log(b);
              }
            });
            // if (this.startDateFilter && this.endDateFilter && this.startDateFilter != this.dateInicial && this.endDateFilter != this.dateInicial) {
            //   console.log("entrou no filtro")
            //   this.filtereditems = await this.items.filter(item => {
            //     const itemDate = new Date(item.date); // Altere a propriedade 'entrada' para o campo que contém a data nos seus dados
            //     itemDate.setHours(0, 0, 0, 0);
            //     return itemDate >= this.startDate && itemDate <= this.endDate;
            //   });
            //   console.log(this.filtereditems)

            // } else {
            this.filtereditems = this.items;
            // }
            this.itemsCompletos = this.items;
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.getItemsFromDynamoDB();
          this.isLoading = false;

          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  async exportToExcel(data: any[]): Promise<void> {
    // console.log(data);
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }

    const columnOrder = [
      'ID',
      'costCenter',
      'date',
      'tipo',
      'totalCost',
      'carrier',
      'status',
      'vehicleType',
      'plate',
      'otherLocationPickup',
      'locationPickup',
      'addressPickup',
      'areaPickup',
      'datePickup',
      'timePickup',
      'otherLocationDelivery',
      'locationDelivery',
      'addressDelivery',
      'areaDelivery',
      'dateDelivery',
      'timeDelivery',
      'distancia',
      'freteCalculado',
      'checked',
      'description',
      'motive',
      'reqEmail',
      'reqId',
      'reqName',
      'reqPhone',
      'reqVehicle',
      'supEmail'
    ];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnOrder);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'C0C0C0' }
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Adicione os dados às linhas da planilha
    data.forEach(item => {
      const row = columnOrder.map(column => item[column]);
      const dataRow = worksheet.addRow(row);
      // Adicione bordas aos dados
      dataRow.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Salve o arquivo modificado
    const outputFilePath = 'viagens_frete_extra.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo modificado');
  }


  async addImageToExcel(item: any): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const imageSrc = 'assets/SCANIA.png';
    const response = await fetch(imageSrc);
    const buffer2 = await response.arrayBuffer();
    let logo = workbook.addImage({
      buffer: buffer2,
      extension: 'jpeg',
    });
    worksheet.addImage(logo, 'B2:C4');

    const imageSrc2 = 'assets/Griffo.png';
    const response2 = await fetch(imageSrc2);
    const buffer3 = await response2.arrayBuffer();
    let logo2 = workbook.addImage({
      buffer: buffer3,
      extension: 'jpeg',
    });
    worksheet.addImage(logo2, 'K2:L4');

    // Defina um objeto com as posições das células e os valores correspondentes
    const cellData = [
      { position: 'B3:N3', value: 'ID: ' + item.ID, isRightAligned: true },
      { position: 'B4:N4', value: 'INSTRUÇÃO DE TRANSPORTE', isBold: true, isCentered: true, backgroundColor: 'FFFACD', border: true },
      { position: 'B6:L6', value: 'LCB - Rua dos Feltrins, 843 - B. Demarchi - SBC - SP', isBold: true, isCentered: true },
      { position: 'B7:L7', value: 'LPC - Rua Comendador João Lucas Vinhedo, 580 - Vinhedo - SP', isBold: true, isCentered: true },
      { position: 'B8:L8', value: 'SLA - Av. José Odorizzi, 151 - São Bernardo - SP', isBold: true, isCentered: true },
      { position: 'M5:N5', value: 'Nº da N.Fiscal' },
      { position: 'M6:N7', value: item.nf, isCentered: true, isBold: true },
      { position: 'M8:N8', value: 'Valor da N.Fiscal' },
      { position: 'M9:N12', value: item.nfTotal, isCentered: true, isBold: true },
      { position: 'B11:C12', value: 'IMPORTANTE:', isBold: true, color: 'FF0000', isCentered: true },
      { position: 'D11:L11', value: '- Para entrega é obrigatório o preenchimento do número e valor da N. Fiscal', color: 'FF0000', isBold: true },
      { position: 'D12:L12', value: '- O endereço constante da NF deve ser o mesmo do destino da mercadoria', color: 'FF0000', isBold: true },
      { position: 'B13:N13', value: 'DADOS PARA LOCALIZAÇÃO DA RETIRADA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B14:I14', value: 'Fornecedor / Cliente:' },
      { position: 'B15:I15', value: item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup + (item.areaPickup ? " - " + item.areaPickup : ""), isBold: true },
      { position: 'J14:L14', value: 'Nome para contato:' },
      { position: 'J15:L15', value: item.contatoPickup, isBold: true },
      { position: 'M14:N14', value: 'Tel. contato:' },
      { position: 'M15:N15', value: item.telefonePickup, isBold: true },
      { position: 'B16:I16', value: 'Descrição do Material:' },
      { position: 'B17:I17', value: item.description, isBold: true },
      { position: 'J16:L16', value: 'Peso Bruto:' },
      { position: 'J17:L17', value: item.weight, isBold: true },
      { position: 'M16:N16', value: 'Quantidade:' },
      { position: 'M17:N17', value: item.quantity, isBold: true },
      { position: 'B18:N18', value: 'Endereço: ' },
      { position: 'B19:N19', value: item.addressPickup, isBold: true },//(this.locais.find(end => end.local == this.item.locationPickup).endereco ? this.locais.find(end => end.local == this.item.locationPickup).endereco : " falta cadastro ") , isBold: true }, //item.addressPickup, isBold: true },
      { position: 'B20:D20', value: 'Cidade: ' },
      { position: 'B21:D21', value: item.cityPickup, isBold: true },
      { position: 'E20:H20', value: 'Estado: ' },
      { position: 'E21:H21', value: item.statePickup, isBold: true },
      { position: 'I20:L20', value: 'Data da retirada: ' },
      { position: 'I21:L21', value: item.datePickup, isBold: true },
      { position: 'M20:N20', value: 'Horário: ' },
      { position: 'M21:N21', value: item.timePickup, isBold: true },
      { position: 'B22:N22', value: 'Motivo: ' },
      { position: 'B23:N24', value: item.motive, isCentered: true, isBold: true },
      { position: 'B25:N25', value: 'DADOS PARA LOCALIZAÇÃO DA ENTREGA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B26:I26', value: 'Fornecedor / Cliente: ' },
      { position: 'B27:I27', value: item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery + (item.areaDelivery ? " - " + item.areaDelivery : ""), isBold: true },
      { position: 'J26:L26', value: 'Nome para contato:' },
      { position: 'J27:L27', value: item.contatoDelivery, isBold: true },
      { position: 'M26:N26', value: 'Tel. contato:' },
      { position: 'M27:N27', value: item.telefoneDelivery, isBold: true },
      { position: 'B28:N28', value: 'Endereço: ' },
      { position: 'B29:N29', value: item.addressDelivery, isBold: true }, // (this.locais.find(end => end.local == this.item.locationDelivery).endereco ? this.locais.find(end => end.local == this.item.locationDelivery).endereco : ""), isBold: true }, //item.addressDelivery, isBold: true },
      { position: 'B30:D30', value: 'Cidade: ' },
      { position: 'B31:D31', value: item.cityDelivery, isBold: true },
      { position: 'E30:H30', value: 'Estado: ' },
      { position: 'E31:H31', value: item.stateDelivery, isBold: true },
      { position: 'I30:J30', value: 'Data da retirada: ' },
      { position: 'I31:J31', value: item.dateDelivery, isBold: true },
      { position: 'K30:N30', value: 'Horário: ' },
      { position: 'K31:N31', value: item.timeDelivery, isBold: true },
      { position: 'B32:N32', value: 'Observações: ' },
      { position: 'B33:N34', value: item.notes, isCentered: true, isBold: true },
      { position: 'B35:N35', value: 'TIPO DE VEÍCULO A SER UTILIZADO', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B36:N40', value: item.vehicleType + " - " + item.plate, isCentered: true, isBold: true },
      { position: 'B41:N41', value: 'PREENCHIMENTO OBRIGATÓRIO', isBold: true, isCentered: true, backgroundColor: 'FFFACD', color: 'FF0000' },
      { position: 'B42:E42', value: 'Solicitante: ', color: 'FF0000' },
      { position: 'B43:E43', value: item.reqName, color: 'FF0000', isBold: true },
      { position: 'F42:H42', value: 'Telefone: ', color: 'FF0000' },
      { position: 'F43:H43', value: item.reqPhone, color: 'FF0000', isBold: true },
      { position: 'I42:N42', value: 'Centro de custo: ', color: 'FF0000' },
      { position: 'I43:N43', value: item.costCenter, color: 'FF0000', isBold: true },
      { position: 'B44:C44', value: 'Cod. Sub.: ', color: 'FF0000' },
      { position: 'B45:C45', value: ' ', color: 'FF0000', isBold: true },
      { position: 'D44:J44', value: 'Tipo Material: ', color: 'FF0000' },
      { position: 'D45:J45', value: item.tipo, color: 'FF0000', isBold: true },
      { position: 'K44:N44', value: 'Pedido de compra: ', color: 'FF0000' },
      { position: 'K45:N45', value: item.projectNumber, color: 'FF0000', isBold: true },
      { position: 'B5:L5', backgroundColor: 'F5FFFA' },
      { position: 'B9:L10', backgroundColor: 'F5FFFA' },
      { position: 'B0:N2', backgroundColor: 'F5FFFA' },


    ];

    // Percorra o objeto cellData e adicione os valores às células
    for (const data of cellData) {
      const cellRange = data.position;
      const valueToFill = data.value;

      // Decodifique a posição da célula de início do intervalo
      const { c: startCol, r: startRow } = XLSX.utils.decode_cell(cellRange.split(':')[0]);

      // Decodifique a posição da célula final do intervalo
      const { c: endCol, r: endRow } = XLSX.utils.decode_cell(cellRange.split(':')[1]);

      // Mesclar as células no intervalo
      worksheet.mergeCells(startRow + 3, startCol, endRow + 3, endCol);

      // Definir o valor da célula mesclada
      // worksheet.getCell(startRow, startCol).value = valueToFill;

      // Definir o valor da célula mesclada
      const cell = worksheet.getCell(startRow + 3, startCol);
      cell.value = valueToFill;

      // Adicionar bordas às células            
      // Configurar bordas se a propriedade border for true
      if (data.border) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      } else {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }

      // Aplicar negrito se a propriedade isBold for true
      if (data.isBold) {
        cell.font = { bold: true };
      }

      // Definir a cor do texto se a propriedade color estiver definida
      if (data.color) {
        cell.font = cell.font || {};
        cell.font.color = { argb: data.color };
      }

      // Centralizar o conteúdo horizontalmente e verticalmente
      if (data.isCentered) {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      }

      // Alinhar o conteúdo à direita se a propriedade isRightAligned for true
      if (data.isRightAligned) {
        cell.alignment = { horizontal: 'right' };
      }

      // Definir a cor de fundo se a propriedade backgroundColor estiver definida
      if (data.backgroundColor) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: data.backgroundColor }
        };
      } else {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'F5FFFA' }
        };
      }
    }
    // Salve o arquivo modificado
    const outputFilePath = 'Instrucao de transporte' + item.ID + '.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo modificado');
  }
}